import { render } from "./AreaPrivada.vue?vue&type=template&id=632ce5b2&scoped=true"
import script from "./AreaPrivada.vue?vue&type=script&lang=js"
export * from "./AreaPrivada.vue?vue&type=script&lang=js"

import "./AreaPrivada.vue?vue&type=style&index=0&id=632ce5b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632ce5b2"]])

export default __exports__